import React from 'react';
import { List, Datagrid, TextField, DateField } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

const rowStyle = (record, index, defaultStyle = {}) => {
    const time = new Date(record.time);
    const now = new Date().getTime();
    const offline = now - time.getTime() > 180000;
    if (record.service && offline)
        return {
            ...defaultStyle,
            borderLeftColor: red[500],
            borderLeftWidth: 5,
            borderLeftStyle: 'solid',
        };
    else if (!offline)
        return {
            ...defaultStyle,
            borderLeftColor: green[500],
            borderLeftWidth: 5,
            borderLeftStyle: 'solid',
        };
    else
        return {
            ...defaultStyle,
            borderLeftColor: 'white',
            borderLeftWidth: 5,
            borderLeftStyle: 'solid',
        };
};

const listStyles = {
    headerRow: {
        borderLeftColor: 'white',
        borderLeftWidth: 5,
        borderLeftStyle: 'solid',
    },
    comment: {
        maxWidth: '18em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};

const DeviceList = ({ classes, ...props }) => (
    <List {...props}>
        <Datagrid rowClick="edit"
                  isRowSelectable={record => false}
                  rowStyle={rowStyle}
                  classes={{ headerRow: classes.headerRow }}>
            <TextField source="id" />
            <TextField source="vehicle" />
            <TextField source="address" />
            <TextField source="version" />
            <TextField source="service" />
            <DateField source="time" showTime />
            <TextField source="x" />
            <TextField source="y" />
            <TextField source="speed" />
            <TextField source="comment" cellClassName={classes.comment} />
        </Datagrid>
    </List>
);

export default withStyles(listStyles)(DeviceList);
